import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import FilterChip from './Filter/FilterChip';

import styles from '../../styles/views/components/TableCaption.module.scss';

const TableCaption = ({
  title,
  filter,
  selectedCheckboxes,
  selectedDropdownOptions,
  datePickers,
}) => (
  <div className={styles.caption}>
    <div className={styles.title}>{title}</div>
    <div className={styles.chips}>
      {selectedCheckboxes.map(checkbox => (
        <FilterChip
          key={checkbox.label}
          text={checkbox.label}
          onCloseIconClick={() => filter.uncheckFilter(checkbox)}
        />
      ))}
      {selectedDropdownOptions.map(([dropdownName, setOfSelectedOptions]) => (
        setOfSelectedOptions.map(option => <FilterChip key={option.label} onCloseIconClick={() => filter.uncheckDropdownOption(dropdownName, option)} text={option.label} />)
      ))}
    </div>
    {datePickers?.createFromDate?.toString() && (
      <div className={styles.chip} style={{ textTransform: 'none' }}>
        <FilterChip
          key={moment(datePickers.createFromDate).format('DD MMMM YYYY')}
          text={`Created from: ${moment(datePickers.createFromDate).format('DD MMMM YYYY')}`}
          hideCloseIcon
        />
      </div>
    )}
    {datePickers?.createToDate?.toString() && (
      <div className={styles.chip} style={{ textTransform: 'none' }}>
        <FilterChip
          key={moment(datePickers.createToDate).format('DD MMMM YYYY')}
          text={`Created to: ${moment(datePickers.createToDate).format('DD MMMM YYYY')}`}
          hideCloseIcon
        />
      </div>
    )}
    {datePickers?.updateFromDate?.toString() && (
      <div className={styles.chip} style={{ textTransform: 'none' }}>
        <FilterChip
          key={moment(datePickers.updateFromDate).format('DD MMMM YYYY')}
          text={`Last update from: ${moment(datePickers.updateFromDate).format('DD MMMM YYYY')}`}
          hideCloseIcon
        />
      </div>
    )}
    {datePickers?.updateToDate?.toString() && (
      <div className={styles.chip} style={{ textTransform: 'none' }}>
        <FilterChip
          key={moment(datePickers.updateToDate).format('DD MMMM YYYY')}
          text={`Last update to: ${moment(datePickers.updateToDate).format('DD MMMM YYYY')}`}
          hideCloseIcon
        />
      </div>
    )}
    {datePickers?.lastLoggedInFromDate?.toString() && (
      <div className={styles.chip} style={{ textTransform: 'none' }}>
        <FilterChip
          key={moment(datePickers.lastLoggedInFromDate).format('DD MMMM YYYY')}
          text={`Last logged in from: ${moment(datePickers.lastLoggedInFromDate).format('DD MMMM YYYY')}`}
          hideCloseIcon
        />
      </div>
    )}
    {datePickers?.lastLoggedInToDate?.toString() && (
      <div className={styles.chip} style={{ textTransform: 'none' }}>
        <FilterChip
          key={moment(datePickers.lastLoggedInToDate).format('DD MMMM YYYY')}
          text={`Last logged in to: ${moment(datePickers.lastLoggedInToDate).format('DD MMMM YYYY')}`}
          hideCloseIcon
        />
      </div>
    )}
    {/* {(selectedCheckboxes.length > 0 || selectedDropdownOptions.length > 0) && (
    <div className={styles.clearAll} onClick={filter.handlers.clearAllFilters}>
      {t('button.clearAllFilters', { ns: i18next.Namespace.COMMON })}
    </div>
    )} */}
  </div>
);

TableCaption.propTypes = {
  title: PropTypes.string.isRequired,
  filter: PropTypes.object.isRequired,
  selectedCheckboxes: PropTypes.array.isRequired,
  selectedDropdownOptions: PropTypes.array,
  datePickers: PropTypes.array.isRequired,
};

TableCaption.defaultProps = {
  selectedDropdownOptions: [],
};

export default TableCaption;
